import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DriverStaticFilterService {
  private readonly sourceCriteria = new BehaviorSubject<DriverStaticFilterCriteria>({
    floorIds: [],
    tagIds: [],
    buildingId: null
  });

  get filterCriteria$(): Observable<DriverStaticFilterCriteria> {
    return this.sourceCriteria.asObservable();
  }

  get filterCriteriaValue(): DriverStaticFilterCriteria {
    return this.sourceCriteria.getValue();
  }

  set filterCriteria(criteria: DriverStaticFilterCriteria) {
    this.sourceCriteria.next(criteria);
  }

  resetFilterCriteria(): void {
    this.sourceCriteria.next({
      floorIds: [],
      tagIds: [],
      buildingId: null
    });
  }

  isEmptyFilterCriteria(): boolean {
    const criteria = this.filterCriteriaValue;
    return criteria.floorIds.length === 0 && criteria.tagIds.length === 0;
  }
}

export interface DriverStaticFilterCriteria {
  floorIds: number[];
  tagIds: number[];
  buildingId?: number;
}
